import { Feature } from '@/pinia/feature'

export const files: Feature = {
  name: 'files',
  enabled: true,
  access: [
    //keep access management?
    'FEAT_FILE_ADMIN',
    'FEAT_FILE_CREATOR',
    'FEAT_FILE_EDITOR',
    'FEAT_FILE_READER',
    'FEAT_LINK_ADMIN',
    'FEAT_LINK_CREATOR',
    'FEAT_LINK_EDITOR',
    'FEAT_LINK_READER'
  ],
  title: {
    en: 'Files',
    sv: 'Filer'
  },
  component: 'FileDirectoryDashboard',
  isRoute: true,
  props: {
    icon: 'IconPaperclip',
    disableIsDrawPointActive: true,
    enableFullscreen: true,
    size: 'small'
  },
  children: []
}
